/**
 * <s-chapter-indicator> — shows the name of the chapter (page region) being read.
 *
 * Reads regions marked `data-chapter="Label"` inside the element named by the `for`
 * attribute (default: <main>), and writes the label of the region crossing the middle
 * of the viewport into its `[data-chapter-label]` child. Decorative: aria-hidden.
 */
class SChapterIndicator extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const scope = document.getElementById(this.getAttribute('for') || '') || document.querySelector('main');
    const output = this.querySelector('[data-chapter-label]');
    const regions = scope ? [...scope.querySelectorAll('[data-chapter]')] : [];
    if (!output || regions.length < 2) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        output.textContent = entry.target.getAttribute('data-chapter');
        this.toggleAttribute('data-visible', true);
      }
    }, { rootMargin: '-50% 0px -50% 0px' });
    regions.forEach((region) => this.#observer.observe(region));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-chapter-indicator')) customElements.define('s-chapter-indicator', SChapterIndicator);
